import axios from "axios";
import router from "../router/index";
import swal from 'sweetalert';
// axios.defaults.withCredentials = true;
axios.defaults.timeout = 5000;
import { Message, MessageBox } from "element-ui";

let domain = document.domain;
let tenantIdConfig = {
  localhost: "10029",
  "bihweb.btghl.net": "10029",
  "www.bih.com.cn": "23"
};
// config: {
//   // 是否自动提示错误
//   isPrompt: true,
//   // 是否显示加载动画
//   load: true,
// },
//请求拦截（配置发送的参数）
axios.interceptors.request.use(
  function(config) {
    const token = localStorage.getItem("WEBTOKEN");
    config.isPrompt = config.isPrompt == null ? true : config.isPrompt;
    //tenantIdConfig[domain]
    console.log('domain',domain,'tenantIdConfig[domain]')
    config.headers.common["tenantId"] = tenantIdConfig[domain];
    config.headers.common["token"] = token || "";
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

//响应拦截（配置返回的数据）
axios.interceptors.response.use(
  function(res) {
    //根据返回的code值来做不同的处理(和后端约定)
    switch (res.data.status) {
      case 200:
        return res.data;
        break;
      case 60114:
        swal({
          title: "提示",
          text: '此操作需要登录, 请先登录',
          icon: "warning",
          buttons: {
            confirm: {
              text: "确认",
              value: true,
              visible: true,
              className: "",
              closeModal: true  
            }
          },
        }).then((willDelete) => {
          if (willDelete) {
            const path = router.app.$route.path;
            let query = router.app.$route.query;
            query.path=path;
            router.push({path:'/login',query});
          } else {
            swal("Your imaginary file is safe!");
          }
        });
        return Promise.reject(res);
        break;
      default:
        if (res.config.isPrompt) {
          Message({
            message: res.data.message,
            type: "warning",
          });
        }
        return Promise.reject(res);
        break;
    }
  },
  function(error) {
    if (error.config.isPrompt) {
      Message({
        message: error.message,
        type: "warning",
      });
    }
    return Promise.reject(error);
  }
);

export default axios;
